import { flatMap, has } from "lodash";
import { useReducer } from "react";
import toast from "react-hot-toast";
import api from "../../apis/axiosInterceptor";

interface Master {
  masterData: object;
  settingMasterData: object;
  DocumentMasterData: object;
  DropdownMasterData: object;
  DropdownMasterOptions: object;
  documentMasterEditData: object;
  DropdownMasterEditData: object;
  error: string;
}

const initialArgs: Master = {
  masterData: {},
  settingMasterData: {},
  DocumentMasterData: {},
  DropdownMasterData: {},
  DropdownMasterOptions: {},
  documentMasterEditData: {},
  DropdownMasterEditData: {},
  error: "",
};

const reducer = (state: Master, action: Master) => {
  return { ...state, ...action };
};

const useMaster = () => {
  const [state, setState] = useReducer(reducer, initialArgs);

  const getDocumentMaster = async () => {
    try {
      const result: any = await api.get(
        `/api/setting-category/type?slug=document`,
      );

      if (result.data.status) {
        setState({
          ...state,
          DocumentMasterData: result.data.data,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const getSettingMaster = async (
    page: string,
    pageSize: string,
    searchText: string,
    sort: string,
    order: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/setting-category?page=${page}&pageSize=${pageSize}&searchValue=${searchText}&sort=${sort}&order=${order}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          settingMasterData: result.data.data[0].rows,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const getDropdownMaster = async (
    page: string,
    pageSize: string,
    searchText: string,
    sort: string,
    order: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/setting?page=${page}&pageSize=${pageSize}&searchValue=${searchText}&sort=${sort}&order=${order}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          DropdownMasterData: result.data.data[0],
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const getDropdownMasterOptions = async (type: string) => {
    try {
      const result: any = await api.get(
        `/api/setting-category/type?slug=${type}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          DropdownMasterOptions: result.data.data,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const DeleteDocumentMaster = async (developerId: string, status: any) => {
    console.log("developerIddeveloperId", developerId, status);
    try {
      const { data } = await api.delete(
        `/developer/status/${developerId}`,
        status,
      );

      if (data.status === true) {
        return true;
      }
    } catch (error) {
      console.info("error => ", error);
      return false;
    }
  };
  const DeleteDropdownMaster = async (developerId: string, status: any) => {
    console.log("developerIddeveloperId", developerId, status);
    try {
      const { data } = await api.delete(
        `/developer/status/${developerId}`,
        status,
      );

      if (data.status === true) {
        return true;
      }
    } catch (error) {
      console.info("error => ", error);
      return false;
    }
  };
  const updateDeveloperStatus = async (developerId: string) => {
    try {
      const result: any = await api.get(`/developer/${developerId}`);

      if (result.data.status) {
        setState({ ...state, documentMasterEditData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  // const updateDropdownMaster = async (developerId: string) => {
  //   try {
  //     const result: any = await api.get(`/developer/${developerId}`);

  //     if (result.data.status) {
  //       setState({ ...state, documentMasterEditData: result.data.data });
  //       return true;
  //     } else {
  //       const errorStr = has(result.data, "errors")
  //         ? Object(flatMap(result.data))[1].msg
  //         : result.data.message;
  //       toast.error(errorStr);
  //       setState({ ...state, error: errorStr });
  //       return false;
  //     }
  //   } catch (error: any) {
  //     toast.error(error.message);
  //     setState({ ...state, error: error.message });
  //     return false;
  //   }
  // };
  // const editDropdownMatser = async (dropdownMasterId: string) => {
  //   console.log("dropdownMasterId => ", dropdownMasterId);

  //   try {
  //     const result: any = await api.get(
  //       `api/setting-category/${dropdownMasterId}`,
  //     );
  //     console.log(" result=> ", result.data.data);

  //     if (result.data.status) {
  //       setState({ ...state, DropdownMasterEditData: result.data.data });
  //       return true;
  //     } else {
  //       const errorStr = has(result.data, "errors")
  //         ? Object(flatMap(result.data))[1].msg
  //         : result.data.message;
  //       toast.error(errorStr);
  //       setState({ ...state, error: errorStr });
  //       return false;
  //     }
  //   } catch (error: any) {
  //     toast.error(error.message);
  //     setState({ ...state, error: error.message });
  //     return false;
  //   }
  // };
  const updateDropdownMaster = async (param: any, dropdownid: any) => {
    const paramObj = {
      ...param,
    };

    try {
      const result: any = await api.put(`/api/setting/${dropdownid}`, paramObj);

      if (result.data.status) {
        // setState({ ...state, documentMasterEditData: result.data.data });
        toast.success(result.data.message);
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  // const editDropdownMatser = async (dropdownMasterId: string) => {
  //   console.log("dropdownMasterId => ", dropdownMasterId);
  //   setState({ ...state, DropdownMasterEditData:{} });
  //   try {
  //     const result: any = await api.get(`api/setting/${dropdownMasterId}`);
  //     console.log(" result=> ", result.data.data);

  //     if (result.data.status) {
  //       setState({ ...state, DropdownMasterEditData: result.data.data });
  //       return true;
  //     } else {
  //       const errorStr = has(result.data, "errors")
  //         ? Object(flatMap(result.data))[1].msg
  //         : result.data.message;
  //       toast.error(errorStr);
  //       setState({ ...state, error: errorStr });
  //       return false;
  //     }
  //   } catch (error: any) {
  //     toast.error(error.message);
  //     setState({ ...state, error: error.message });
  //     return false;
  //   }
  // };
  const createDropdownMaster = async (param: any) => {
    const paramObj = {
      ...param,
    };
    console.log("paramObj => ", paramObj);

    try {
      // const formData = new FormData();
      const result: any = await api.post("/api/setting", paramObj);
      console.log("resultfromPostApi => ", result);

      if (result.data.status) {
        // toast.success(result.data.message);
        toast.success(result.data.message);
        setState({ ...state, masterData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };

  return {
    getDocumentMaster,
    getSettingMaster,
    getDropdownMaster,
    updateDeveloperStatus,
    updateDropdownMaster,
    DeleteDocumentMaster,
    DeleteDropdownMaster,
    getDropdownMasterOptions,
    // editDropdownMatser,
    createDropdownMaster,
    ...state,
  };
};

export default useMaster;
